var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildingBlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "150px",
    width: "150px",
    fill: "#00b369",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3,15.3c-0.1,0-0.2,0.1-0.3,0.1v3.8l0.4,0.2c1,0.5,1.6,1.5,1.6,2.7v4.2l7.4-3.7c0.3-0.2,0.6-0.5,0.6-0.9V10.5L50.3,15.3z  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4,13.5l9.3-4.7l-9.3-4.7c-0.3-0.1-0.6-0.1-0.9,0l-9.3,4.7l9.3,4.7C48.8,13.7,49.2,13.7,49.4,13.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48,15.5c-0.1,0-0.2-0.1-0.3-0.1L38,10.5v2.4l10,5.3V15.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5,12.3c-0.3-0.2-0.6-0.2-0.9,0l-16.4,8.6l16.4,8.6c0.3,0.2,0.6,0.2,0.9,0l16.4-8.6L32.5,12.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16,15.5v2.7l10-5.3v-2.4l-9.7,4.8C16.2,15.4,16.1,15.4,16,15.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4,13.5l9.3-4.7l-9.3-4.7c-0.3-0.1-0.6-0.1-0.9,0L5.2,8.9l9.3,4.7C14.8,13.7,15.2,13.7,15.4,13.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6,22.5l7.4,3.7v-4.2c0-1.1,0.6-2.1,1.6-2.7l0.4-0.2v-3.8c-0.1,0-0.2-0.1-0.3-0.1L4,10.5v11.1C4,22,4.2,22.4,4.6,22.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19,38v2.9h-2V37l-1.6-0.8c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3,0-0.4,0.1l-9.3,4.7l9.8,4.9l9.8-4.9L19,38z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4,53.6c0,0.4,0.2,0.7,0.6,0.9h0l9.4,4.7V47.5l-10-5V53.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16,59.3l9.4-4.7c0.3-0.2,0.6-0.5,0.6-0.9V42.5l-10,5V59.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14,22.5v11.8c0.8-0.3,1.6-0.2,2.3,0.1l0.7,0.3v-0.9c0-1.1,0.6-2.1,1.6-2.7l3.9-2.1l0.9,1.8l-3.9,2.1  c-0.3,0.2-0.5,0.5-0.5,0.9v1.9l7.3,3.7c1,0.5,1.7,1.5,1.7,2.7v7.5l3,1.6V31.4c-0.1,0-0.3-0.1-0.4-0.2L14,22.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45,33.8c0-0.4-0.2-0.7-0.5-0.9l-3.9-2.1l0.9-1.8l3.9,2.1c1,0.5,1.6,1.5,1.6,2.7v0.9l0.7-0.3c0.7-0.4,1.6-0.4,2.3-0.1V22.5  l-16.6,8.7c-0.1,0.1-0.3,0.1-0.4,0.2v19.8l3-1.6v-7.5c0-1.1,0.6-2.2,1.7-2.7l7.3-3.7V33.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4,36.2c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3,0-0.4,0.1L47,37v3.9h-2V38l-5.8,2.9l9.8,4.9l9.8-4.9L49.4,36.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38,53.6c0,0.4,0.2,0.7,0.6,0.9h0l9.4,4.7V47.5l-10-5V53.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50,59.3l9.4-4.7c0.3-0.2,0.6-0.5,0.6-0.9V42.5l-10,5V59.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingBlock);
export default __webpack_public_path__ + "static/media/building_block.7d54639a1bd2ab6158be9eeeae64f68b.svg";
export { ForwardRef as ReactComponent };